@if (getMedia(product()); as media) {
  <img
    loading="lazy"
    [src]="media.src"
    [alt]="media.alt"
    [srcset]="media.srcset"
    [sizes]="
      '(min-width: 360px) 165px, ' + '(min-width: 576px) 200px,' + ' 125px'
    "
  />
} @else {
  <img
    src="/assets/images/misc/placeholder/product-placeholder.png"
    loading="lazy"
    alt="no-image"
    class="is-missing"
  />
}
